import { Outlet } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";

export default function PublicLayout() {
    return (
        <>
            <Navbar />
            <main className="bg-carbon text-crema min-h-screen">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppButton />
        </>
    );
}
